import React, { useRef, useState, useEffect } from "react";
import useHttp from "../../../../hooks/use-http";
import moment from "moment";
import { toast } from "react-toastify";

import numberToWords from "number-to-words";
import Modal from "react-modal";
import { dateConversion } from "../../../../components/Validation";
const WorkServiceOrderForm = (props) => {
  const [selectedDate, setSelectedDate] = useState(
    new Date().toISOString().substr(0, 10)
  );

  const handleDateChange = (e) => {
    setSelectedDate(e.target.value);
  };

  const [loading, setLoading] = useState(false);

  const currentDate = new Date().toISOString().slice(0, 10);

  const frmRef = useRef({});

  var d = new Date();
  var dateString =
    d.getDate() +
    "/" +
    (d.getMonth() + 1) +
    "/" +
    d.getFullYear() +
    " " +
    d.getHours() +
    ":" +
    d.getMinutes() +
    ":" +
    d.getSeconds();

  const productRef = useRef({});
  const { sendRequest: postWorkServiceOrder } = useHttp();

  const { sendRequest: getEmp } = useHttp();

  const [employeeId, setEmployeeId] = useState();
  const [employeeData, setEmployeeData] = useState([]);
  const [taxs, setTaxs] = useState();
  const [vendorDetails, setVendorDetails] = useState([]);

  const { sendRequest: getVendor } = useHttp();

  const [close, setClose] = useState(false);
  const [labourDetails, setLabourDetails] = useState([]);
  const [costInWords, setCostInWords] = useState();
  const [total, setTotalValue] = useState({
    labour: 0,
    transfer: 0,
    meal: 0,
    dispercentage: 0,
    taxId: 0,
  });

  const [currancys, setCurrancys] = useState([]);

  const [currencyId, setCurrencyId] = useState([]);

  const [vendorId, setVendorId] = useState(0);

  const [servicDealTypeId, setServicDealTypeId] = useState();

  const [docNo, setDocNo] = useState();

  const [taxId, setTaxId] = useState();
  const [taxAmount, setTaxAmount] = useState(0);
  const [discountAmount, setDiscountAmount] = useState(0);
  const [totalAmount, setTotalAmount] = useState(0);
  const roundValue = 2;

  const customModalStyles = {
    overlay: {
      backgroundColor: "rgba(0, 0, 0, 0.5)",
      zIndex: 1000,
      top: 50,
      left: 40,
    },
    content: {
      top: "50%",
      left: "50%",
      transform: "translate(-50%, -50%)",
      maxWidth: "80%",
      width: "700px",
      minHeight: "500px",
      height: "80%",
      minHeight: "auto",
      overflow: "auto",
      border: "5px solid #96dc00",
    },
  };

  useEffect(() => {
    frmRef.current.time_stamp.value =
      (d.getHours() < 10 ? "0" : "") +
      d.getHours().toString() +
      ":" +
      (d.getMinutes() < 10 ? "0" : "") +
      d.getMinutes().toString();
    //console.log("time_stamp1",d.getMinutes().toString())
  }, [employeeData]);

  const { sendRequest: getLoadVendor } = useHttp();

  useEffect(() => {
    getEmp(
      {
        url: `/api/employee/?useCase=Warehouse&orgId=${localStorage.getItem(
          "orgId"
        )}`,
        //url: `/api/getEmps/?orgId=${localStorage.getItem("orgId")}`,
      },
      (data) => {
        ////console.log("emp", data.output);
        setEmployeeData(data.output);
      }
    );
  }, [getEmp]);

  const { sendRequest: getwsoIds } = useHttp();

  useEffect(() => {
    // getwsoIds(
    //   {
    //     url: `/api/workServiceOrder/?orgId=${localStorage.getItem("orgId")}`,
    //   },
    //   (data) => {
    //     //console.log("DATA",data);
    //     var lastWsoId = 0;
    //     if (data.length > 0) {
    //       lastWsoId = data[data.length - 1].wsoId;
    //     }
    //      //console.log(lastWsoId+1);
    //     const dn =
    //       "wo/" +
    //       parseInt(localStorage.getItem("warehouseId")) +
    //       "/" +
    //       (lastWsoId + 1);
    //     //console.log(dn);
    //     setDocNo(dn);
    //   }
    // );
  }, [getwsoIds]);

  const { sendRequest: getCurrency } = useHttp();

  useEffect(() => {
    getCurrency(
      {
        url: `/api/currencies/`,
      },
      (res) => {
        if (res) {
          setCurrancys(res);
          //console.log(res);
        }
      }
    );
  }, [getCurrency]);

  const { sendRequest: getTaxs } = useHttp();

  useEffect(() => {
    getTaxs(
      {
        url: `/api/tax/`,
      },
      (res) => {
        if (res) {
          // //console.log(res);
          setTaxs(res);
        }
      }
    );
  }, [getTaxs, props.update]);

  useEffect(() => {
    var serviceOrderAmount = 0;
    var discountAmount = 0;
    var amountafterdiscount = 0;

    var basicAmount =
      parseInt(total.labour) +
      parseFloat(total.meal) +
      parseFloat(total.transfer);
    basicAmount = basicAmount.toFixed(roundValue);

    ////console.log(total.dispercentage);

    frmRef.current.lineTotalAmount.value = basicAmount;
    discountAmount = (basicAmount * parseFloat(total.dispercentage)) / 100;
    discountAmount = discountAmount.toFixed(roundValue);

    amountafterdiscount = basicAmount - discountAmount;
    // //console.log(discountAmount);
    frmRef.current.discountAmount.value = discountAmount;
    // amountafterdiscount = amountafterdiscount;

    frmRef.current.total_amount.value = amountafterdiscount;

    ////console.log(amountafterdiscount);

    const filteredTaxPer =
      taxs &&
      taxs
        .filter((item) => parseInt(item.taxId) === parseInt(total.taxId))
        .map((item) => item.taxPercentage);

    // //console.log("taxId", total.taxId, filteredTaxPer);

    var taxAmt = parseFloat((amountafterdiscount / 100) * filteredTaxPer) || 0;

    taxAmt = taxAmt.toFixed(roundValue);

    frmRef.current.taxAmount.value = parseFloat(taxAmt);

    // //console.log(taxAmt);

    setTaxAmount(taxAmt);

    serviceOrderAmount = parseFloat(amountafterdiscount) + parseFloat(taxAmt);

    frmRef.current.totalWorkOrderAmount.value = serviceOrderAmount || 0;

    const totalCost1 = serviceOrderAmount || 0;
    const totalCostInWords = convertFloatToWords(totalCost1);

    ////console.log(totalCostInWords);

    setCostInWords(totalCostInWords);

    // //console.log(serviceOrderAmount);
  }, [total, taxs]);

  useEffect(() => {
    getVendor(
      {
        url: `/api/getVendorNames/?orgId=${localStorage.getItem("orgId")}`,
      },
      (res) => {
        if (res) {
          setVendorDetails(res);
        }
      }
    );
  }, [getVendor]);

  const loadVendorData = (id) => {
    setVendorId(id);
    getLoadVendor(
      {
        url: `/api/addVendor/?vendorId=${id}`,
      },
      (res) => {
        if (res) {
          frmRef.current.vendor_id.value = res.vendorId;
          frmRef.current.vendor_name.value = res.vendorName || "";
        }
      }
    );
  };

  const { sendRequest: getLabour } = useHttp();

  const getLabourData = (id) => {
    getLabour(
      {
        url: `/api/get_wso_labour_by_wsoId/?wsoId=${id}`,
      },
      (res) => {
        //  //console.log(res);
        if (res) {
          setLabourDetails(res);
        }
      }
    );
  };

  const submitHandler = (e) => {
    e.preventDefault();
    setLoading(true);
    const data = {
      wsoDate: moment(frmRef.current.date.value).format("DD/MM/YYYY"),
      wsoDocNo: docNo,
      timeStamp: frmRef.current.time_stamp.value,
      vendorId: vendorId,
      currencyId: frmRef.current.currency.value,
      supervisorEmployeeId: frmRef.current.emp_id.value,
      serviceDealType: frmRef.current.servic_deal_type.value,
      labourCount: frmRef.current.labour_count.value,
      labourDocument: frmRef.current.labourDocs.value,
      work_service_order_labour: labourDetails,
      labourCost: frmRef.current.labour_cost.value,
      labourTransportCost: frmRef.current.labour_transport_cost.value,
      labourMealCost: frmRef.current.labour_meal_cost.value,
      lineTotalAmount: frmRef.current.lineTotalAmount.value,
      discountPercentage: parseFloat(
        frmRef.current.discountPercentage.value || 0
      ),
      discountAmount: parseFloat(frmRef.current.discountAmount.value),
      totalAmount: frmRef.current.total_amount.value,
      taxId: frmRef.current.tax.value,
      taxAmount: frmRef.current.taxAmount.value,
      totalWorkOrderAmount: frmRef.current.totalWorkOrderAmount.value,
      remark: frmRef.current.remark.value,
      createdBy: parseInt(localStorage.getItem("id")),
      orgId: localStorage.getItem("orgId"),
      amountChargeable: frmRef.current.amt_chargeable.value,
      status: 1,
      warehouseId: parseInt(localStorage.getItem("warehouseId")),
      createdDate: dateString,
      serviceId: props.sId,
    };

    if (props.update) {
      data["wsoId"] = props.update.wsoId;
    }
    ////console.log(data);
    postWorkServiceOrder(
      {
        url: "/api/workServiceOrder/",
        method: props.update ? "PUT" : "POST",
        body: data,
      },
      (data) => {
        toast.success(`Work Order ${props.update ? "Updated" : "Added"}`);
        props.addForm(false);
        setLoading(false);
      },
      (error) => {
        console.error("Error", error);
        toast.error(error);
        setLoading(false);
      }
    );
  };

  //Edit Data Bind
  useEffect(() => {
    //  //console.log(props.update);
    if (props.update) {
      getLabourData(props.update.wsoId);

      // getTaxs();

      var wsoDate = dateConversion(
        props.update.wsoDate,
        "DD/MM/YYYY",
        "YYYY-MM-DD"
      );

      frmRef.current.date.value = props.update.wsoDate;

      setSelectedDate(wsoDate);

      frmRef.current.emp_id.value = props.update.SupervisorEmployeeId;
      frmRef.current.time_stamp.value = moment(
        props.update.timeStamp,
        "HH:mm"
      ).format("hh:mm");
      //  frmRef.current.time_stamp.value = props.update.timeStamp;
      setDocNo(props.update.wsoDocNo);
      frmRef.current.vendor_name.value = props.update.vendorId;
      frmRef.current.labourDocs.value = props.update.labourDocument;
      setVendorId(props.update.vendorId);
      setCurrencyId(props.update.currencyId);
      setTaxId(props.update.taxId);
      setEmployeeId(props.update.SupervisorEmployeeId);
      //  //console.log("emp id", props.update.SupervisorEmployeeId);
      frmRef.current.taxAmount.value = props.update.taxAmount;

      frmRef.current.servic_deal_type.value = props.update.serviceDealType;
      frmRef.current.labour_count.value = props.update.labourCount;
      setLabourDetails(props.update.labourDetails);
      frmRef.current.labour_cost.value = props.update.labourCost;
      frmRef.current.labour_transport_cost.value =
        props.update.labourTransportCost;
      frmRef.current.labour_meal_cost.value = props.update.labourMealCost;
      frmRef.current.currency.value = props.update.currency;
      frmRef.current.lineTotalAmount.value = props.update.lineTotalAmount;
      frmRef.current.taxAmount.value = props.update.taxAmount;

      frmRef.current.discountPercentage.value = props.update.discountPercentage;
      frmRef.current.discountAmount.value = props.update.discountAmount;
      frmRef.current.total_amount.value = props.update.totalAmount;
      frmRef.current.totalWorkOrderAmount.value =
        props.update.totalWorkOrderAmount;

      frmRef.current.remark.value = props.update.remark;
      setTotalValue({
        ...total,
        labour: props.update.labourCost,
        transfer: props.update.labourTransportCost,
        meal: props.update.labourMealCost,
        dispercentage: props.update.discountPercentage,
        taxId: props.update.taxId,
      });
    }
  }, [props.update]);

  const submitLabour = (e) => {
    var strlabourName = productRef.current.labourName.value;
    var strgender = productRef.current.gender.value;
    var strage = productRef.current.age.value;
    var strisInsured = productRef.current.isInsured.checked;
    var strcontactNo = productRef.current.contactNumber.value;

    // e.preventDefault();
    setLabourDetails((x) => [
      ...x,
      {
        lineSrNo: labourDetails.length + 1,
        labourName: strlabourName,
        gender: strgender,
        age: strage,
        isInsured: strisInsured,
        contactNo: strcontactNo,
        createdBy: parseInt(localStorage.getItem("id")),
        orgId: localStorage.getItem("orgId"),
        status: 1,
        createdDate: dateString,
      },
    ]);

    productRef.current.labourName.value = "";
    productRef.current.gender.value = "";
    productRef.current.age.value = "";
    //productRef.current.isInsured.checked;
    productRef.current.contactNumber.value = "";

    ////console.log(labourDetails);

    // productRef.current.labourName.value="";
    // productRef.current.age.value="";
    // productRef.current.contactNumber.value="";
    // productRef.current.isInsured.checked=false;
  };
  useEffect(() => {
    if (labourDetails && labourDetails.length > 0) {
      //productRef.current.labourName.value="";
      // productRef.current.age.value="";
      // productRef.current.contactNumber.value="";
      // productRef.current.isInsured.checked=false;
    }
  }, [labourDetails]);

  useEffect(() => {
    clearLabour();
  }, [labourDetails]);

  const clearLabour = () => {
    frmRef.current.labour_count.value = labourDetails && labourDetails.length;
    /*  productRef.current.labourName.value="";
    productRef.current.contactNumber.value="";
    productRef.current.age.value="";
    productRef.current.isInsured.checked=false;
    productRef.current.gender.selected="Male";*/
  };

  const handleDelete = (index, e) => {
    var labourDetails1 =
      labourDetails && labourDetails.filter((v, i) => i !== index);

    setLabourDetails(labourDetails1);
  };

  const convertFloatToWords = (number) => {
    // Convert the float number to words
    const words = numberToWords.toWords(number);

    // Split the words by space
    const wordArray = words.split(" ");

    // Check if there is a decimal part
    const decimalPart = Math.round(number * 100) % 100;
    if (decimalPart > 0) {
      const decimalWords = numberToWords.toWords(decimalPart);
      wordArray.push("and");
      wordArray.push(decimalWords);
    }

    // Combine the words into a single string
    return wordArray.join(" ");
  };

  return (
    <>
      {close && (
        <Modal isOpen={close} style={customModalStyles}>
          <div>
            <div className="">
              <div className="">
                <h3 className="card-title">Labour Details</h3>
                <div className="card-tools text-right">
                  <button
                    type="button"
                    className="btn btn-tool"
                    data-card-widget="remove"
                    onClick={() => setClose(false)}
                  >
                    <i className="fas fa-times" />
                  </button>
                  <hr />
                </div>
              </div>
            </div>

            <div className="row">
              <div className="col-md-4">
                <label htmlFor={"labourName"}> Labour Name</label>
                <input
                  type={"input"}
                  id={"labourName"}
                  required
                  ref={(el) => (productRef.current["labourName"] = el)}
                  className="form-control"
                />
              </div>
              <div className="col-md-4">
                <label htmlFor={"gender"}> Gender</label>
                <select
                  id="gender"
                  className="form-control"
                  ref={(el) => (productRef.current["gender"] = el)}
                >
                  <option value="Male">Male</option>
                  <option value="Female">Female</option>
                </select>
              </div>

              <div className="col-md-4">
                <label htmlFor={"age"}>Age</label>
                <input
                  type={"text"}
                  id={"age"}
                  required
                  ref={(el) => (productRef.current["age"] = el)}
                  className="form-control"
                />
              </div>
            </div>

            <div className="row">
              <div className="col-md-4">
                <label htmlFor={"isInsured"}>Is Insured?</label>
                <input
                  type={"checkbox"}
                  id={"isInsured"}
                  ref={(el) => (productRef.current["isInsured"] = el)}
                  className="form-control"
                />
              </div>
              <div className="col-md-4">
                <label htmlFor={"contactNumber"}>Contact Number</label>
                <input
                  type={"text"}
                  id={"contactNumber"}
                  required
                  ref={(el) => (productRef.current["contactNumber"] = el)}
                  className="form-control"
                />
              </div>
              <div className="col-md-2">
                <br />
                <button
                  className="btn  btn-primary mx-2 my-2"
                  onClick={(e) => {
                    submitLabour(e);
                    //  clearLabour();
                  }}
                >
                  +
                </button>
              </div>
            </div>

            <hr />

            <div className="divverticlascroll">
              <table className="table table-bordered text-center">
                <thead>
                  <tr>
                    <th>Sr. No</th>
                    <th>Labour Name</th>
                    <th>Gender</th>
                    <th>Age</th>
                    <th>Is Insured?</th>
                    <th>Contact Number</th>
                    <th>Edit</th>
                    <th>Delete</th>
                  </tr>
                </thead>

                <tbody>
                  {labourDetails &&
                    labourDetails.map((itm, i) => {
                      return (
                        <tr key={i}>
                          <td>{itm.lineSrNo}</td>

                          <td>{itm.labourName}</td>
                          <td>{itm.gender}</td>

                          <td>{itm.age}</td>
                          <td>{itm.isInsured ? "Yes" : "No"}</td>
                          <td>{itm.contactNo}</td>
                          <td>
                            {" "}
                            <button
                              className="btn"
                              //  onClick={(e) => handleDelete(i, e)}
                            >
                              <i className="fas fa-edit"></i>
                            </button>
                          </td>

                          <td>
                            {" "}
                            <button
                              className="btn"
                              onClick={(e) => handleDelete(i, e)}
                            >
                              <i className="fas fa-trash"></i>
                            </button>
                          </td>
                        </tr>
                      );
                    })}
                </tbody>
              </table>
            </div>
            <hr />

            <div className="text-center">
              <div className="">
                <button
                  className="btn btn-primary mx-2 my-2"
                  onClick={() => {
                    labourDetails.map((x) => (x["isSave"] = true));
                    setClose(false);
                  }}
                >
                  Save
                </button>
              </div>
            </div>
          </div>
        </Modal>
      )}

      <div className="content-wrapper">
        <div>&nbsp;</div>
        <section className="content">
          <form style={{ margin: "10px" }} onSubmit={submitHandler}>
            <div className="container-fluid">
              {/* SELECT2 EXAMPLE */}
              <div className="card card-default">
                <div className="card-header">
                  <h3 className="card-title">Add Work Service Order</h3>
                  <div className="card-tools">
                    <button
                      type="button"
                      className="btn btn-tool"
                      data-card-widget="remove"
                      onClick={() => props.addForm(false)}
                    >
                      <i className="fas fa-times" />
                    </button>
                  </div>
                </div>
                {/* /.card-header */}
                <div className="card-body">
                  <div className="row">
                    <div className="col-md-4">
                      <label htmlFor={"date"}>{"Date "}</label>
                      <input
                        type={"date"}
                        id={"date"}
                        required
                        ref={(el) => (frmRef.current["date"] = el)}
                        className="form-control"
                        max={currentDate}
                        value={selectedDate}
                        onChange={handleDateChange}
                      />
                    </div>

                    <div className="col-md-4">
                      <label htmlFor={"time_stamp"}>{"TimeStamp"}</label>
                      <input
                        type={"time"}
                        id={"time_stamp"}
                        required
                        ref={(el) => (frmRef.current["time_stamp"] = el)}
                        className="form-control"
                      />
                    </div>

                    <div className="col-md-4">
                      <label htmlFor={"emp_id"}>
                        {"Assigned Supervisor Employee id"}
                      </label>

                      <select
                        id="emp_id"
                        className="form-control"
                        ref={(el) => (frmRef.current["emp_id"] = el)}
                        value={employeeId}
                        required
                        onChange={(e) => {
                          setEmployeeId(e.target.value);
                        }}
                      >
                        {/* {employeeId &&
                    employeeId.map((x) => <option value={x}>{x}</option>)}
                */}
                        <option selected disabled value="">
                          --Select Employee--
                        </option>
                        {employeeData &&
                          employeeData.map((x) => (
                            <option
                              key={x.empId}
                              employee-id={x.empId}
                              value={x.empId}
                              selected={
                                props.update &&
                                x.empId === props.update.supervisorEmployeeId
                              }
                            >
                              {x.employeeName}
                            </option>
                          ))}
                      </select>
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-md-4">
                      <label>{"Vendor Name"}</label>
                      <select
                        id="vendor_name"
                        className="form-control"
                        required
                        value={vendorId}
                        ref={(el) => (frmRef.current["vendor_name"] = el)}
                        onChange={(e) => {
                          loadVendorData(e.target.value);
                        }}
                      >
                        <option value="">--Select--</option>
                        {vendorDetails &&
                          vendorDetails.map((x) => (
                            <option
                              key={x.vendorId}
                              vendor-id={x.vendorId}
                              value={x.vendorId}
                            >
                              {x.vendorName}
                            </option>
                          ))}
                      </select>
                    </div>
                    <div className="col-md-4">
                      <label htmlFor={"currency"}>{"Currency"}</label>
                      <select
                        id="currency"
                        className="form-control"
                        required
                        onChange={(e) => {
                          setCurrencyId(e.target.value);
                        }}
                        ref={(el) => (frmRef.current["currency"] = el)}
                        value={currencyId}
                      >
                        <option value="">--Select--</option>

                        {currancys &&
                          currancys.map((x) => (
                            <option
                              key={x.currencyId}
                              value={x.currencyId}
                              currency-id={x.currencyId}
                            >
                              {x.country.currencyName}
                            </option>
                          ))}
                      </select>
                    </div>

                    <div className="col-md-4">
                      <label htmlFor={"servic_deal_type"}>
                        {"Service Deal Type"}
                      </label>
                      <select
                        id="servic_deal_type"
                        className="form-control"
                        required
                        value={servicDealTypeId}
                        ref={(el) => (frmRef.current["servic_deal_type"] = el)}
                      >
                        {" "}
                        <option value="">--Select--</option>
                        <option value="1">Hourly</option>
                        <option value="2">Fix set of hours</option>
                        <option value="3">Work Based</option>
                        <option value="4">Number of Days</option>
                        <option value="5">Other</option>
                      </select>
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-md-4">
                      <label htmlFor={"labourDocs"}>{"Labour Document"}</label>
                      <input
                        type={"text"}
                        id={"labourDocs"}
                        required
                        ref={(el) => (frmRef.current["labourDocs"] = el)}
                        className="form-control"
                      />
                    </div>

                    <div className="col-md-4">
                      <label htmlFor={"labour_details"}>
                        {"Labour Details"}
                      </label>{" "}
                      <br />
                      <button
                        type={"button"}
                        id={"labour_details"}
                        required={labourDetails ? false : true}
                        onClick={() => {
                          setClose(true);
                        }}
                        ref={(el) => (frmRef.current["labour_details"] = el)}
                        className="btn btn-sm  btn-success mx-2 my-2"
                      >
                        Add
                      </button>
                    </div>

                    <div className="col-md-4">
                      <label htmlFor={"labour_count"}>{"Labour Count"}</label>
                      <input
                        type={"text"}
                        id={"labour_count"}
                        required
                        ref={(el) => (frmRef.current["labour_count"] = el)}
                        className="form-control"
                        readOnly
                      />
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-md-4">
                      <label htmlFor={"labour_cost"}>{"Labour Cost"}</label>
                      <input
                        type={"text"}
                        id={"labour_cost"}
                        value={total.labour}
                        onChange={(e) =>
                          setTotalValue({ ...total, labour: e.target.value })
                        }
                        required
                        ref={(el) => (frmRef.current["labour_cost"] = el)}
                        className="form-control"
                      />
                    </div>

                    <div className="col-md-4">
                      <label htmlFor={"labour_transport_cost"}>
                        {"Labour Transport Cost"}
                      </label>
                      <input
                        type={"text"}
                        id={"labour_transport_cost"}
                        value={total.transfer}
                        onChange={(e) =>
                          setTotalValue({ ...total, transfer: e.target.value })
                        }
                        required
                        ref={(el) =>
                          (frmRef.current["labour_transport_cost"] = el)
                        }
                        className="form-control"
                      />
                    </div>

                    <div className="col-md-4">
                      <label htmlFor={"labour_meal_cost"}>
                        {"Labour Meal Cost"}
                      </label>
                      <input
                        type={"text"}
                        id={"labour_meal_cost"}
                        required
                        value={total.meal}
                        onChange={(e) =>
                          setTotalValue({ ...total, meal: e.target.value })
                        }
                        ref={(el) => (frmRef.current["labour_meal_cost"] = el)}
                        className="form-control"
                      />
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-md-4">
                      <label htmlFor={"lineTotalAmount"}>
                        {"Sub Total Amount"}
                      </label>
                      <input
                        type={"text"}
                        id={"lineTotalAmount"}
                        disabled
                        required
                        ref={(el) => (frmRef.current["lineTotalAmount"] = el)}
                        className="form-control"
                      />
                    </div>

                    <div className="col-md-4">
                      <label htmlFor={"discountPercentage"}>
                        {"Discount Percentage"}
                      </label>
                      <input
                        type={"text"}
                        id={"discountPercentage"}
                        onChange={(e) =>
                          setTotalValue({
                            ...total,
                            dispercentage: e.target.value,
                          })
                        }
                        ref={(el) =>
                          (frmRef.current["discountPercentage"] = el)
                        }
                        className="form-control"
                      />
                    </div>

                    <div className="col-md-4">
                      <label htmlFor={"discountAmount"}>
                        {"Discount Amount"}
                      </label>
                      <input
                        type={"text"}
                        id={"discountAmount"}
                        disabled
                        required
                        ref={(el) => (frmRef.current["discountAmount"] = el)}
                        className="form-control"
                      />
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-md-4">
                      <label htmlFor={"total_amount"}>{"Total Amount"}</label>
                      <input
                        type={"text"}
                        id={"total_amount"}
                        disabled
                        required
                        ref={(el) => (frmRef.current["total_amount"] = el)}
                        className="form-control"
                      />
                    </div>
                    <div className="col-md-4">
                      <label htmlFor={"tax"}> {"Tax"}</label>
                      <select
                        id="tax"
                        className="form-control"
                        value={taxId}
                        ref={(el) => (frmRef.current["tax"] = el)}
                        // onChange={handleTaxChange}

                        onChange={(e) => {
                          setTaxId(e.target.value);
                          setTotalValue({ ...total, taxId: e.target.value });
                        }}
                      >
                        <option value="">Select</option>
                        {taxs &&
                          taxs.map((x) => (
                            <option key={x.taxId} value={x.taxId}>
                              {x.taxName}
                            </option>
                          ))}
                      </select>
                    </div>
                    <div className="col-md-4">
                      <label htmlFor={"taxAmount"}>{"Tax Amount"}</label>
                      <input
                        type={"text"}
                        id={"taxAmount"}
                        disabled
                        required
                        ref={(el) => (frmRef.current["taxAmount"] = el)}
                        className="form-control"
                        value={taxAmount}
                      />
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-md-4">
                      <label htmlFor={"tatotalWorkOrderAmountxAmount"}>
                        {"Work Order Amount"}
                      </label>
                      <input
                        type={"text"}
                        id={"totalWorkOrderAmount"}
                        disabled
                        required
                        ref={(el) =>
                          (frmRef.current["totalWorkOrderAmount"] = el)
                        }
                        className="form-control"
                      />
                    </div>
                    <div className="col-md-4">
                      <label htmlFor={"amt_chargeable"}>
                        {" "}
                        {"Amount Chargeable"}
                      </label>
                      <textarea
                        // type={"text"}
                        id={"amt_chargeable"}
                        required
                        ref={(el) => (frmRef.current["amt_chargeable"] = el)}
                        //className="inputs currancy-value"
                        value={costInWords}
                        rows="2"
                        cols="32"
                        style={{ resize: "none" }}
                        disabled
                      ></textarea>
                    </div>

                    <div className="col-md-4">
                      <label htmlFor={"remark"}>{"Remark/Note"}</label>
                      <input
                        type={"text"}
                        id={"remark"}
                        ref={(el) => (frmRef.current["remark"] = el)}
                        className="form-control"
                      />
                    </div>
                  </div>

                  <div className="row"></div>

                  <div className="row">
                    <div className="col-md-4"></div>
                    <div className="flexColumn">
                      {/* <div className="flexColumn">
                <label htmlFor={"vendor_id"}>{"Vendor id"}</label>
                <input
                  type={"text"}
                  id={"vendor_id"}
                  required
                  disabled
                  ref={(el) => (frmRef.current["vendor_id"] = el)}
                   className="form-control"
                />
              </div> */}
                    </div>
                    <div className="col-md-4">
                      {/* <div className="flexColumn">
                <label htmlFor={"currency"}>{"Currency"}</label>


                <select
                id="currency"
                 className="form-control"
                ref={(el) => (frmRef.current["currency"] = el)}
              >
   <option >
           --Select--
                    </option>

                {currancys &&
                  currancys.map((x) => (
                    <option key={x.currencyId} value={x.currencyId}>
                      {x.country.currencyName}
                    </option>
                  ))}
              </select>


                
              </div>*/}
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-md-4"></div>
                    <div className="col-md-1"> </div>
                    <div className="col-md-1">
                      {" "}
                      <button
                        type="submit"
                        className="btn btn-primary"
                        disabled={loading}
                      >
                        {loading ? "Submitting..." : "Submit"}
                      </button>
                    </div>
                    <div className="col-md-1">
                      {/* <button className="btn  btn-primary mx-2 my-2" type="submit">
                Cancel
              </button> */}
                    </div>
                    <div className="col-md-1"> </div>
                    <div className="col-md-4"></div>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </section>
      </div>
    </>
  );
};

export default WorkServiceOrderForm;
